var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3",
    "data-name": "Group 3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 119.692,
    height: 46.26,
    viewBox: "0 0 119.692 46.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 119.692,
    height: 46.26,
    fill: "#fff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M0,110.106v1.612H2.495v6.6H4.452v-6.6h2.49v-1.612Z",
    transform: "translate(0 -72.163)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M47.994,114.29a2.678,2.678,0,0,0,.373-1.45A2.807,2.807,0,0,0,48,111.382a2.416,2.416,0,0,0-1.037-.947,3.575,3.575,0,0,0-1.594-.331H41.979v8.213h1.985v-2.811h1.017l1.5,2.811h2.165l-1.7-3.127a2.359,2.359,0,0,0,1.05-.9m-4.03-2.585h.979a1.966,1.966,0,0,1,.75.126.958.958,0,0,1,.461.377,1.173,1.173,0,0,1,.156.632,1.131,1.131,0,0,1-.156.624.93.93,0,0,1-.459.361,2.076,2.076,0,0,1-.752.118h-.979Z",
    transform: "translate(-27.513 -72.163)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M84.411,110.105l-2.771,8.213h2.133l.54-1.724H87.15l.541,1.724h2.133l-2.771-8.213Zm.375,4.981.912-2.911h.064l.914,2.911Z",
    transform: "translate(-53.507 -72.163)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M131.979,114.838h-.068l-3.232-4.732H126.97v8.213h1.985v-4.74h.052l3.268,4.74h1.684v-8.213h-1.981Z",
    transform: "translate(-83.216 -72.163)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M175.218,114.131a2.937,2.937,0,0,0-.786-.525,5.013,5.013,0,0,0-1.077-.353l-.706-.161a4,4,0,0,1-.505-.14,1.707,1.707,0,0,1-.383-.186.757.757,0,0,1-.241-.247.574.574,0,0,1-.074-.325.672.672,0,0,1,.132-.4.841.841,0,0,1,.385-.275,1.774,1.774,0,0,1,.641-.1,1.427,1.427,0,0,1,.9.247.939.939,0,0,1,.355.688h1.9a2.413,2.413,0,0,0-.4-1.347,2.562,2.562,0,0,0-1.093-.9,3.945,3.945,0,0,0-1.658-.323,4.1,4.1,0,0,0-1.664.321,2.718,2.718,0,0,0-1.143.894,2.2,2.2,0,0,0-.409,1.335,1.873,1.873,0,0,0,.61,1.482,3.727,3.727,0,0,0,1.68.792l.858.2a4.673,4.673,0,0,1,.74.226,1.127,1.127,0,0,1,.431.289.617.617,0,0,1,.144.4.714.714,0,0,1-.156.441.991.991,0,0,1-.435.3,1.913,1.913,0,0,1-.684.108,2.01,2.01,0,0,1-.768-.136,1.164,1.164,0,0,1-.519-.4,1.248,1.248,0,0,1-.213-.662h-1.9a2.849,2.849,0,0,0,.437,1.592,2.535,2.535,0,0,0,1.191.938,4.783,4.783,0,0,0,1.8.309,4.647,4.647,0,0,0,1.755-.3,2.443,2.443,0,0,0,1.117-.854,2.3,2.3,0,0,0,.393-1.335,2.363,2.363,0,0,0-.169-.89,2.052,2.052,0,0,0-.483-.7",
    transform: "translate(-110.881 -71.95)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M210.52,118.318H212.5v-3.3h3.264V113.4H212.5v-1.684h3.621v-1.612H210.52Z",
    transform: "translate(-137.974 -72.163)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M248.681,118.318h5.726v-1.612h-3.741v-1.688h3.449V113.4h-3.449v-1.684h3.741v-1.612h-5.726Z",
    transform: "translate(-162.985 -72.163)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M293.927,114.29a2.678,2.678,0,0,0,.373-1.45,2.806,2.806,0,0,0-.365-1.458,2.415,2.415,0,0,0-1.037-.947,3.575,3.575,0,0,0-1.594-.331h-3.393v8.213H289.9v-2.811h1.017l1.5,2.811h2.165l-1.7-3.127a2.358,2.358,0,0,0,1.05-.9m-4.03-2.585h.979a1.968,1.968,0,0,1,.75.126.958.958,0,0,1,.461.377,1.177,1.177,0,0,1,.156.632,1.134,1.134,0,0,1-.156.624.93.93,0,0,1-.459.361,2.076,2.076,0,0,1-.752.118H289.9Z",
    transform: "translate(-188.697 -72.163)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M334.445,114.833a2.044,2.044,0,0,0-.483-.7,2.946,2.946,0,0,0-.786-.526,5.03,5.03,0,0,0-1.077-.353l-.705-.161a3.99,3.99,0,0,1-.506-.14,1.71,1.71,0,0,1-.383-.186.761.761,0,0,1-.241-.247.58.58,0,0,1-.074-.325.675.675,0,0,1,.132-.4.84.84,0,0,1,.385-.275,1.775,1.775,0,0,1,.642-.1,1.427,1.427,0,0,1,.9.246.941.941,0,0,1,.355.688h1.9a2.415,2.415,0,0,0-.4-1.348,2.562,2.562,0,0,0-1.093-.9,3.944,3.944,0,0,0-1.658-.323,4.091,4.091,0,0,0-1.664.321,2.718,2.718,0,0,0-1.143.894,2.207,2.207,0,0,0-.409,1.335,1.873,1.873,0,0,0,.61,1.482,3.725,3.725,0,0,0,1.68.792l.858.2a4.689,4.689,0,0,1,.74.226,1.129,1.129,0,0,1,.431.289.617.617,0,0,1,.144.4.712.712,0,0,1-.156.441.989.989,0,0,1-.435.3,1.913,1.913,0,0,1-.684.108,2.008,2.008,0,0,1-.768-.136,1.162,1.162,0,0,1-.519-.4,1.246,1.246,0,0,1-.213-.661h-1.9a2.852,2.852,0,0,0,.437,1.592,2.537,2.537,0,0,0,1.191.938,4.781,4.781,0,0,0,1.8.309,4.644,4.644,0,0,0,1.754-.3,2.445,2.445,0,0,0,1.117-.854,2.3,2.3,0,0,0,.393-1.335,2.363,2.363,0,0,0-.168-.89",
    transform: "translate(-214.921 -71.95)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M24.372,31.75H32.62L21.908,0H11.691L.978,31.75H9.226l2.089-6.666H22.279Z",
    transform: "translate(-0.641 0.001)",
    fill: "#ffe800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M33.689,33.233l4.549-14,4.54,14L38.239,29.91Z",
    transform: "translate(-22.08 -12.607)",
    fill: "#101b2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M102.743,31.75V0h13.116a12.9,12.9,0,0,1,6.162,1.388,9.851,9.851,0,0,1,4.008,3.861,11.394,11.394,0,0,1,1.411,5.744,11.189,11.189,0,0,1-1.434,5.744,9.7,9.7,0,0,1-4.085,3.806,13.724,13.724,0,0,1-6.295,1.349h-8.092V15.844H114.2a6.288,6.288,0,0,0,2.907-.605,4.145,4.145,0,0,0,1.775-1.7,5.182,5.182,0,0,0,.6-2.55,5.128,5.128,0,0,0-.6-2.55A4.072,4.072,0,0,0,117.1,6.774a6.444,6.444,0,0,0-2.9-.589h-3.783V31.75Z",
    transform: "translate(-67.338 0.001)",
    fill: "#ffe800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M185.341,31.75V0H207.48V6.232H193.015v6.512h13.333v6.248H193.015v6.527H207.48V31.75Z",
    transform: "translate(-121.472 0.001)",
    fill: "#ffe800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M269.148,0l5.8,10.031h.248L281.055,0h8.589l-9.581,15.875,9.891,15.876h-8.806l-5.953-10.139h-.248l-5.953,10.139h-8.744l9.844-15.876L260.5,0Z",
    transform: "translate(-170.567 0)",
    fill: "#ffe800"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fad5ea6034be0056cd6ca534f53ce4bd.svg";
export { ForwardRef as ReactComponent };